import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import _ from 'lodash';
import moment from 'moment';
import { initialize, reset as resetForm, destroy } from 'redux-form';
import { onClickDraftAction } from '../actionsDrafts/actionsDraftsScripts';
import types from './types';

const URL_ACTION = `${BASE_API}/action`;
const URL_ACTION_PAGE = `${BASE_API}/actions-list-table`;
const URL_ACTION_TOTAL_PAGE = `${BASE_API}/actions/total`;
const URL_ACTION_ARCHIVE = `${BASE_API}/archive-action`;
const URL_ACTION_PUBLISH = `${BASE_API}/publish-action`;
const URL_ACTIONS_TO_STATIONS = `${BASE_API}/actions-to-stations`;
const URL_ACTION_RESULTS = `${BASE_API}/action-results`;
const URL_DUPLICATE = `${BASE_API}/duplicate-action-partner`;

export const onClickActionResults = (
  action,
  router = undefined,
  previousRoute = undefined
) => {
  return (dispatch) => {
    if (action.type_id === 7 || action.type_id === 8 || action.type_id === 6) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/aquisicao-clientes/pesquisa/resultados/?action=${action.id}&from=${previousRoute}`
        );
      }
    } else if (action.type_id === 4) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/curso-presencial/resultados/?action=${action.id}&from=${previousRoute}`
        );
      }
    } else if (action.type_id === 14) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/entregar-produto/resultados/?action=${action.id}&from=${previousRoute}`
        );
      }
    } else if (action.type_id === 3) {
      router.push(
        `/owner/acoes/cupons/resultados/?action=${action.id}&from=${previousRoute}`
      );
    } else if (action.type_id === 2) {
      router.push(
        `/owner/acoes/signup-earn/resultados/?action=${action.id}&from=${previousRoute}`
      );
    } else if (action.type_id === 5) {
      router.push(
        `/owner/acoes/compartilhe/resultados/?action=${action.id}&from=${previousRoute}`
      );
    } else if (action.type_id === 1) {
      router.push(
        `/owner/acoes/member-get-member/resultados/?action=${action.id}&from=${previousRoute}`
      );
    } else if (action.type_id === 16) {
      router.push(
        `/owner/acoes/conteudo-s-i/resultados/?action=${action.id}&from=${previousRoute}`
      );
    } else if (action.type_id === 17) {
      router.push(
        `/owner/acoes/atividade-doacao/resultados/?action=${action.id}&from=${previousRoute}`
      );
    } else if (action.type_id === 18) {
      router.push(
        `/owner/acoes/video-playlist/resultados/?action=${action.id}&from=${previousRoute}`
      );
    }
  };
};

export const getActionResults = (action_id) => {
  return (dispatch) => {
    dispatch({
      type: 'ACTION_RESULTS_LOAD',
      payload: true,
    });
    axios
      .get(`${URL_ACTION_RESULTS}/${action_id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'ACTION_RESULTS_FETCHED',
            payload: response.data,
          },
        ]);
      });
  };
};

export const getStationActiveActions = (id) => {
  return (dispatch) => {
    dispatch({ type: 'ACTIVE_ACTIONS_LOAD', payload: true });
    axios
      .get(
        `${URL_ACTION_PAGE}/?where[active]=1&&where[partner_id]=${id}&&where[is_draft]=0&&where[station_id]=notnull`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        for (let i in response.data) {
          response.data[i]['createdAtDate'] = moment(
            response.data[i].createdAt
          ).format('DD/MM/YYYY HH:mm:ss');
          response.data[i]['startDate'] = moment(response.data[i].start).format(
            'DD/MM/YYYY HH:mm:ss'
          );
          response.data[i]['endDate'] = moment(response.data[i].end).format(
            'DD/MM/YYYY HH:mm:ss'
          );
        }
        dispatch([
          {
            type: 'ACTIVE_ACTIONS_FETCHED',
            payload: response.data,
          },
        ]);
      });
  };
};

export const getLazyStationActiveActions = (id, lazy) => {
  return (dispatch) => {
    dispatch({ type: 'ACTIVE_ACTIONS_LOAD', payload: true });
    axios
      .get(
        `${URL_ACTION_PAGE}/?where[active]=1&&where[partner_id]=${id}&&where[is_draft]=0\
        &&where[station_id]=notnull&&where[limit]=${lazy.rows}&&where[offset]=${lazy.page}\
        &&where[order]=${lazy.sortField} ${lazy.sortOrder}\
        &&where[filters]=${JSON.stringify(lazy.filters)}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        for (let i in response.data) {
          response.data[i]['createdAtDate'] = moment(
            response.data[i].createdAt
          ).format('DD/MM/YYYY HH:mm:ss');
          response.data[i]['startDate'] = moment(response.data[i].start).format(
            'DD/MM/YYYY HH:mm:ss'
          );
          response.data[i]['endDate'] = moment(response.data[i].end).format(
            'DD/MM/YYYY HH:mm:ss'
          );
        }
        dispatch([
          {
            type: 'ACTIVE_ACTIONS_FETCHED',
            payload: response.data,
          },
        ]);
      });
  };
};

export const getTotalNumberActiveActions = (id, lazy) => {
  return (dispatch) => {
    dispatch({ type: 'ACTIVE_ACTIONS_TOTAL_LOAD', payload: true });
    axios
      .get(
        `${URL_ACTION_TOTAL_PAGE}/?where[active]=1&&where[partner_id]=${id}&&where[is_draft]=0\
        &&where[station_id]=notnull&&where[filters]=${JSON.stringify(lazy.filters)}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        dispatch([
          {
            type: 'ACTIVE_ACTIONS_TOTAL_FETCHED',
            payload: response.data,
          },
        ]);
      });
  };
};

export const duplicateAction = (action, router, setBackDrop) => {
  return (dispatch) => {
    setBackDrop(true);
    axios
      .post(
        `${URL_DUPLICATE}/${action.id}`,
        {},
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        dispatch([
          onClickDraftAction(response.data, router),
          setBackDrop(false),
        ]);
      })
      .catch((e) => {
        try {
          for (const i in e.response.data) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data[i]}`,
                variant: 'error',
                open: true,
              },
            });
          }

          setBackDrop(false);
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });

          setBackDrop(false);
        }
      });
  };
};

export const getLazyPartnerWaitingApprovalActions = (id, lazy) => {
  return (dispatch) => {
    dispatch({ type: 'ACTIVE_ACTIONS_LOAD', payload: true });
    axios
      .get(
        `${URL_ACTION_PAGE}?where[active]=1&&where[partner_id]=${id}&&where[is_draft]=0\
        &&where[limit]=${lazy.rows}&&where[offset]=${lazy.page}\
        &&where[order]=${lazy.sortField} ${lazy.sortOrder}\
        &&where[filters]=${JSON.stringify(lazy.filters)}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        for (let i in response.data) {
          response.data[i]['createdAtDate'] = moment(
            response.data[i].createdAt
          ).format('DD/MM/YYYY HH:mm:ss');
          response.data[i]['startDate'] = moment(
            response.data[i].createdAt
          ).format('DD/MM/YYYY HH:mm:ss');
          response.data[i]['endDate'] = moment(
            response.data[i].createdAt
          ).format('DD/MM/YYYY HH:mm:ss');
        }
        dispatch([
          {
            type: 'ACTIVE_ACTIONS_FETCHED',
            payload: response.data,
          },
        ]);
      });
  };
};

export const getTotalNumberWaitingApprovalActions = (id, lazy) => {
  return (dispatch) => {
    dispatch({ type: 'ACTIVE_ACTIONS_TOTAL_LOAD', payload: true });
    axios
      .get(
        `${URL_ACTION_TOTAL_PAGE}?where[active]=1&&where[partner_id]=${id}&&where[is_draft]=0\
        &&where[filters]=${JSON.stringify(lazy.filters)}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        dispatch([
          {
            type: 'ACTIVE_ACTIONS_TOTAL_FETCHED',
            payload: response.data,
          },
        ]);
      });
  };
};

export const getActionDetail = (id) => {
  return (dispatch) => {
    dispatch({
      type: types.DETAIL_LOAD,
      payload: true,
    });
    axios
      .get(`${URL_ACTION}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.DETAIL_FETCHED,
            payload: response.data,
          },
        ]);
      });
  };
};

export const onClickAction = (action, router = undefined) => {
  return (dispatch) => {
    if (action.type_id === 7 || action.type_id === 8 || action.type_id === 6) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/aquisicao-clientes/pesquisa/${action.id}/editar`
        );
      }
    }
    if (action.type_id === 4) {
      if (!_.isUndefined(router)) {
        router.push(`/owner/acoes/curso-presencial/${action.id}/editar`);
      }
    } else if (action.type_id === 14) {
      if (!_.isUndefined(router)) {
        router.push(`/owner/acoes/entregar-produto/${action.id}/editar`);
      }
    } else if (action.type_id === 3) {
      router.push(`/owner/acoes/cupons/${action.id}/editar`);
    } else if (action.type_id === 2) {
      router.push(`/owner/acoes/signup-earn/${action.id}/editar`);
    } else if (action.type_id === 1) {
      router.push(`/owner/acoes/member-get-member/${action.id}/editar`);
    } else if (action.type_id === 5) {
      router.push(`/owner/acoes/compartilhe/${action.id}/editar`);
    } else if (action.type_id === 16) {
      router.push(`/owner/acoes/conteudo-s-i/${action.id}/editar`);
    } else if (action.type_id === 17) {
      router.push(`/owner/acoes/atividade-doacao/${action.id}/editar`);
    } else if (action.type_id === 18) {
      router.push(`/owner/acoes/video-playlist/${action.id}/editar`);
    }
  };
};

export const onClickActionShare = (action, router = undefined) => {
  return (dispatch) => {
    if (action.type_id === 7 || action.type_id === 8 || action.type_id === 6) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/aquisicao-clientes/pesquisa/divulgar/?action=${action.id}`
        );
      }
    }
    if (action.type_id === 4) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/curso-presencial/divulgar/?action=${action.id}`
        );
      }
    } else if (action.type_id === 14) {
      if (!_.isUndefined(router)) {
        router.push(
          `/owner/acoes/entregar-produto/divulgar/?action=${action.id}`
        );
      }
    } else if (action.type_id === 3) {
      router.push(`/owner/acoes/cupons/divulgar/?action=${action.id}`);
    } else if (action.type_id === 2) {
      router.push(`/owner/acoes/signup-earn/divulgar/?action=${action.id}`);
    } else if (action.type_id === 5) {
      router.push(`/owner/acoes/compartilhe/divulgar/?action=${action.id}`);
    } else if (action.type_id === 1) {
      router.push(
        `/owner/acoes/member-get-member/divulgar/?action=${action.id}`
      );
    } else if (action.type_id === 16) {
      router.push(`/owner/acoes/conteudo-s-i/divulgar/?action=${action.id}`);
    } else if (action.type_id === 17) {
      router.push(
        `/owner/acoes/atividade-doacao/divulgar/?action=${action.id}`
      );
    } else if (action.type_id === 18) {
      router.push(`/owner/acoes/video-playlist/divulgar/?action=${action.id}`);
    }
  };
};
export const reset = (form) => {
  return resetForm(form);
};

export const initializeForm = (form, values) => {
  return initialize(form, values);
};

export const remove = (id, resolve, reject, station_id) => {
  return (dispatch) => {
    axios
      .put(
        `${URL_ACTION_ARCHIVE}/${id}`,
        { active: 0 },
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        dispatch([getStationActiveActions(station_id), resolve()]);
      });
  };
};

export const publishAction = (
  id,
  station_id,
  formName,
  router,
  message,
  loadType
) => {
  return (dispatch) => {
    axios
      .put(
        `${URL_ACTION_PUBLISH}/${id}`,
        {},
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        const newValues = {
          partner: response.data.partner_id,
          action: response.data.id,
          stations: [station_id],
          message,
        };
        axios
          .post(`${URL_ACTIONS_TO_STATIONS}`, newValues, {
            headers: {
              Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
            },
            onUploadProgress: (progressEvent) =>
              dispatch([
                {
                  type: 'SUBMIT_PROGRESS',
                  payload: `${Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  )} %`,
                },
              ]),
          })
          .then((actionsToStationsResponse) => {
            dispatch([
              {
                type: 'SUBMIT_PROGRESS',
                payload: 0,
              },
              {
                type: 'SNACKBAR',
                payload: {
                  message: 'Operação realizada com sucesso',
                  variant: 'success',
                  open: true,
                },
              },
              {
                type: loadType,
                payload: false,
              },
            ]);
            router.push('/owner/acoes/minhas-atividades/?to=online');
            if (formName) dispatch(destroy(formName));
          })
          .catch((e) => {
            dispatch([
              {
                type: 'SUBMIT_PROGRESS',
                payload: 0,
              },
            ]);
            try {
              for (const i in e.response.data) {
                dispatch({
                  type: 'SNACKBAR',
                  payload: {
                    message: `${e.response.data[i]}`,
                    variant: 'error',
                    open: true,
                  },
                });
              }
            } catch (error) {
              dispatch({
                type: 'SNACKBAR',
                payload: { message: 'Erro', variant: 'error', open: true },
              });
            }
          });
      })
      .catch((e) => {
        try {
          for (const i in e.response.data) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data[i]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};
